export const cartProducts = state => {
  return state.added.map(({ /* id, quantity, prices, details */ quantity, product}) => {
 //
    return {
      ...product,
      quantity,// prices, details
    }
  })
}
export const userId  = state => {
  return state.user.id
}